module.exports = __webpack_public_path__ + "img/laptop-alert.612237c9.png";